<script setup>
defineProps({
  count: { type: Number, default: 1 },
  flexDirection: { type: String, default: 'column' },
});
</script>

<template>
  <div class="cards" :style="{ flexDirection }">
    <div v-for="item in count" :key="item" class="card skeleton-loading" />
  </div>
</template>

<style scoped>
.cards {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
}

.card {
  border: 1px solid var(--md-border);
  width: var(--small-thumbnail-width);
  height: var(--small-thumbnail-height);
}
</style>
